/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type AnalyticsEventType = (typeof AnalyticsEventType)[keyof typeof AnalyticsEventType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AnalyticsEventType = {
  SESSION_START: 'SESSION_START',
  SESSION_END: 'SESSION_END',
  VIDEO_START: 'VIDEO_START',
  VIDEO_END: 'VIDEO_END',
  VIDEO_EXIT: 'VIDEO_EXIT',
  VIDEO_PROGRESS: 'VIDEO_PROGRESS',
  BUTTON_CLICK: 'BUTTON_CLICK',
  EXTERNAL_LINK: 'EXTERNAL_LINK',
  MODAL_CLOSE: 'MODAL_CLOSE',
  SURVEY_GATE_ARRIVAL: 'SURVEY_GATE_ARRIVAL',
  SCENE_JUMP: 'SCENE_JUMP',
} as const
